const events = {
  INTEGRATIONS_IMPORT_HR_OPEN: 'integrations:import-hr:open',
  INTEGRATIONS_IMPORT_HR_CLOSE_VUE_ROUTER:
    'integrations:import-hr:close-VUE_ROUTER',
  INTEGRATIONS_IMPORT_HR_OPEN_VUE_ROUTER:
    'integrations:import-hr:open-VUE_ROUTER',
  INTEGRATIONS_IMPORT_HR_OPEN_CONFIG_VUE_ROUTER:
    'integrations:import-hr:open-config-VUE_ROUTER',
  INTEGRATIONS_BULK_IMPORT_UPDATE_OPEN: 'integrations:bulk-import-update:open',
  INTEGRATIONS_BULK_IMPORT_HISTORY_OPEN:
    'integrations:bulk-import-history:open',
  INTEGRATIONS_BULK_IMPORT_HISTORY_OPEN_VUE_ROUTER:
    'integrations:bulk-import-history:open-vue-router',
  INTEGRATIONS_BULK_IMPORT_UPDATE_OPEN_VUE_ROUTER:
    'integrations:bulk-import-update:open-vue-router',
  INTEGRATIONS_BULK_IMPORT_UPDATE_SUCCESS:
    'integrations:bulk-import-update:success',
  IMPORT_DIRECTORY_CONNECT_CLICK: 'import-hr:directory-click',
  IMPORT_HR_CONFIGURATION_SETUP: 'import-hr:configuration:setup',
  IMPORT_CONFIGURATION_START_IMPORT: 'import:configuration:import:start',
  IMPORT_CONFIGURATION_IMPORT_SUCCESS: 'import:configuration:import:success',
  IMPORT_HR_CONFIGURATION_IMPORT_FAILURE:
    'import-hr:configuration:import:failure',
  IMPORT_CONFIGURATION_START_IMPORT_SKIP_EMPLOYEES:
    'import:configuration:import:skip-employees:start',
  IMPORT_CONFIGURATION_SKIP_EMPLOYEES_IMPORT_SUCCESS:
    'import:configuration:skip-employees:import:success',
  IMPORT_CONFIGURATION_SKIP_EMPLOYEES_IMPORT_FAILURE:
    'import:configuration:skip-employees:import:failure',
  INTEGRATIONS_PROVIDER_DIRECTORY_OPEN: 'integrations:provider-directory:open',
  INTEGRATIONS_PROVIDER_DIRECTORY_CLOSED_VUE_ROUTER:
    'integrations:provider-directory:closed-vue-router',
  INTEGRATIONS_UPDATE_LOCATION_MAPPING_SELECTION:
    'integrations:update:location:mapping:selection',
  INTEGRATIONS_IMPORT_SALES_OPEN: 'integrations:import-sales:open',
  INTEGRATIONS_TIMESHEET_EXPORT_OPEN: 'integrations:timesheet-export:open',
  INTEGRATIONS_TIMESHEET_EXPORT_ADP_OPEN:
    'integrations:timesheet-export-adp:open',
  INTEGRATIONS_CONNECT_FOR_EMPLOYEE_SYNC_OPEN:
    'integrations:connect-for-employee-sync:open',
  INTEGRATIONS_TIMESHEET_EXPORT_RESUME_NEW_EXPORT:
    'integrations:timesheet-export:resume-new-export',
  INTEGRATIONS_TIMESHEET_EXPORT_XERO_CHECK_INTEGRATIONS:
    'integrations:timesheet-export-xero:check-integrations',
  INTEGRATIONS_TIMESHEET_EXPORT_XERO_TOGGLE_LOADER_VISIBILITY:
    'integrations:timesheet-export-xero:toggle-loader-visibility',
  INTEGRATIONS_TIMESHEET_EXPORT_XERO_TRIGGER_SYNC_EVENT:
    'integrations:timesheet-export-xero:trigger-sync-event',
  INTEGRATIONS_TIMESHEET_EXPORT_XERO_LOAD_EXPORT_BUTTON:
    'integrations:timesheet-export-xero:load-export-button',
  INTEGRATIONS_UPDATE_RADIO_SELECTION: 'integrations:update:radio:selection',
  INTEGRATIONS_MODAL_CLOSED: 'closed',
  IMPORT_DIRECTORY_EDIT_CLICK: 'import:edit:directory-click',
  IMPORT_DIRECTORY_REDIRECT_CLICK: 'import:redirect:directory-click',
  INTEGRATIONS_UPDATE_MODEL_VALUE: 'update:modelValue',
  INTEGRATIONS_DIRECTORY_DELETE_CONFIGURATION: 'delete:remove-config',
  INTEGRATIONS_ADVANCED_OPEN: 'integrations:advanced:open',
  INTEGRATIONS_TIMESHEET_STAGING_ACTION_PANEL_BUTTONS_UPDATE:
    'integrations-timesheet-staging-action-panel-buttons:update',
  INTEGRATIONS_CONFIGURATION_CREATED: 'integrations:configuration:created',
  INTEGRATIONS_CONFIGURATION_UPDATED: 'integrations:configuration:updated',
  INTEGRATIONS_TIMESHEET_EXPORT_STATUS: 'timesheet-export-status',
  INTEGRATIONS_BULK_EXPORT_OPEN: 'integrations:bulk-export:open',
  INTEGRATIONS_BULK_EXPORT_SUCCESS: 'integrations:bulk-export:success',
  INTEGRATIONS_IMPORT_SALES_OPEN_CONFIG_VUE_ROUTER:
    'integrations:import-sales:open-config-VUE_ROUTER',
  INTEGRATIONS_IMPORT_SALES_OPEN_VUE_ROUTER:
    'integrations:import-sales:open-VUE_ROUTER',
  INTEGRATIONS_ADVANCED_CLOSED: 'integrations:advanced:closed',
  INTEGRATIONS_ADVANCED_CHANGE_TAB: 'integrations:advanced:change-tab',
  INTEGRATIONS_TIMESHEET_EXPORT_MANDATORY_FIELDS_WARNING_OPEN:
    'integrations:timesheet-export-mandatory-field-warning:open',
  INTEGRATIONS_BULK_IMPORT_FILE_DOWNLOAD_OPTIONS_OPEN:
    'integrations:bulk-import:file-download-options',
  TIMESHEET_BULK_EXPORT_REQUESTED: 'TIMESHEET_BULK_EXPORT_REQUESTED',
  TIMESHEET_BULK_EXPORT_STARTED: 'TIMESHEET_BULK_EXPORT_STARTED',
  TIMESHEET_BULK_EXPORT_SUCCEEDED: 'TIMESHEET_BULK_EXPORT_SUCCEEDED',
  TIMESHEET_BULK_EXPORT_FAILED: 'TIMESHEET_BULK_EXPORT_FAILED',
};

export { events };
export default events;
